import { Component, inject, Input, OnInit } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss']
})
export class ConfirmPopUpComponent implements OnInit {
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
  @Input() title: string = '';
  @Input() eventBroadcast: string = '';
  ngOnInit(): void {
    Object.keys(this).forEach((key) => {
      if (typeof this[key] !== 'function' && this.nzModalData[key]) {
        this[key] = this.nzModalData[key];
      }
    })
  }
}
